import { render, staticRenderFns } from "./PaymentMethodSelectionPanel.vue?vue&type=template&id=39a70400"
import script from "./PaymentMethodSelectionPanel.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelectionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports